import { Component, Input } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { TimeOffPolicy } from '@models/time-off-v3/time-off-policy.model';
import { TimeOffCreateFlowService } from '@time-off-v3/services';

@Component({
    selector: 'app-accrual-settings-update-card',
    templateUrl: './accrual-settings-update-card.template.html',
    styleUrls: ['./accrual-settings-update-card.style.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class AccrualSettingsUpdateCardComponent {
    @Input() timeOffPolicy = new TimeOffPolicy();

    constructor(private readonly timeOffCreateFlowService: TimeOffCreateFlowService) {}

    resetTimeOffPolicyAccrualValues(): void {
        // Need to remove the frequency when the accrual type changes from 'accruing' to 'unlimited'
        this.timeOffPolicy.accrualFrequency = undefined;
        this.timeOffPolicy.daysAccruedPerPeriod = undefined;

        if (!this.timeOffPolicy.isUnlimited) {
            this.timeOffPolicy.accrualFrequency =
                this.timeOffCreateFlowService.timeOffPolicyDefaultValues.accrualFrequency;
        }

        this.timeOffPolicy.resetDateValues(this.timeOffPolicy);
    }
}
